import { TriggerType } from '@katanaperps/katana-perps-sdk';
import React from 'react';

import { ApiTriggerType } from '#/api/types';
import Dropdown from '#/components/basic/inputs/Dropdown';

export default function TriggerTypeDropdown({
  selected,
  onChange,
}: {
  selected: ApiTriggerType;
  onChange: (type: ApiTriggerType) => void;
}) {
  return (
    <Dropdown
      selected={selected}
      onChange={onChange}
      options={[
        { label: 'Last', value: TriggerType.last },
        { label: 'Index', value: TriggerType.index },
      ]}
      noBorder
    />
  );
}
